export const ERROR_TITLE = 'Something went wrong!';
export const ERROR_DESCRIPTION =
  'We want to hear from you.  Please try again later.';
